module.exports = __webpack_public_path__ + "img/5_70.0a25ffe8.png";